import Parse from 'html-react-parser';

function BMP20210(props) {
    let svgCode =
    `<svg width="28" height="52" viewBox="0 0 28 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4678 19.3496C16.98 18.4897 18 16.864 18 15C18 12.2386 15.7614 10 13 10C10.2386 10 8 12.2386 8 15C8 16.5676 8.72137 17.9667 9.85027 18.8834L8.72017 20.5397C7.06543 19.2594 6 17.2541 6 15C6 11.134 9.13401 8 13 8C16.866 8 20 11.134 20 15C20 17.5504 18.6361 19.7822 16.5979 21.0058L15.4678 19.3496Z" fill="${props.highlightColour}"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4678 45.3496C16.98 44.4897 18 42.864 18 41C18 38.2386 15.7614 36 13 36C10.2386 36 8 38.2386 8 41C8 42.5676 8.72137 43.9667 9.85027 44.8834L8.72017 46.5397C7.06543 45.2594 6 43.2541 6 41C6 37.134 9.13401 34 13 34C16.866 34 20 37.134 20 41C20 43.5504 18.6361 45.7822 16.5979 47.0058L15.4678 45.3496Z" fill="${props.highlightColour}" fill-opacity="0.5"/>
    </svg>`

    props.svgReturn(67, svgCode, "bmp00210", 28, 52);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20210;